<template>
  <div class="min-h-screen bg-app-bg-light dark:bg-app-bg-dark transition-colors duration-300 p-6 md:p-8 lg:p-12">
    <div class="max-w-7xl mx-auto">
      <!-- Bienvenida -->
      <div class="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-6 md:p-8 mb-6">
        <div class="flex items-center justify-between">
          <div>
            <h1 class="text-2xl md:text-3xl font-bold text-slate-800 dark:text-slate-200 mb-2">
              Bienvenido, {{ user?.Nombres }} {{ user?.Apellidos }}
            </h1>
            <p class="text-slate-600 dark:text-slate-400">
              Rol: <span class="font-semibold">{{ user?.Rol }}</span>
            </p>
          </div>
          <div class="hidden md:block">
            <i class="bx bx-hotel text-custom-primary text-6xl"></i>
          </div>
        </div>
      </div>

      <!-- Información -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Card 1 -->
        <div class="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-6">
          <div class="flex items-center mb-4">
            <div class="bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg mr-4">
              <i class="bx bx-info-circle text-blue-600 dark:text-blue-400 text-3xl"></i>
            </div>
            <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-200">
              Sistema de Gestión Hotelera
            </h3>
          </div>
          <p class="text-slate-600 dark:text-slate-400 text-sm">
            Bienvenido al sistema de gestión del {{ brand.nombre }}.
            Utiliza el menú lateral para acceder a las funciones disponibles según tu rol.
          </p>
        </div>

        <!-- Card 2 -->
        <div class="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-6">
          <div class="flex items-center mb-4">
            <div class="bg-green-100 dark:bg-green-900/30 p-3 rounded-lg mr-4">
              <i class="bx bx-check-circle text-green-600 dark:text-green-400 text-3xl"></i>
            </div>
            <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-200">
              Acceso Configurado
            </h3>
          </div>
          <p class="text-slate-600 dark:text-slate-400 text-sm">
            Tu cuenta está activa y configurada. Si necesitas acceso a funciones adicionales,
            contacta al administrador del sistema.
          </p>
        </div>

        <!-- Card 3 -->
        <div class="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-6">
          <div class="flex items-center mb-4">
            <div class="bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg mr-4">
              <i class="bx bx-time text-purple-600 dark:text-purple-400 text-3xl"></i>
            </div>
            <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-200">
              Fecha y Hora
            </h3>
          </div>
          <p class="text-slate-600 dark:text-slate-400 text-sm">
            <strong>{{ fechaActual }}</strong>
          </p>
          <p class="text-slate-500 dark:text-slate-500 text-xs mt-1">
            {{ horaActual }}
          </p>
        </div>

        <!-- Card 4 -->
        <div class="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-6">
          <div class="flex items-center mb-4">
            <div class="bg-orange-100 dark:bg-orange-900/30 p-3 rounded-lg mr-4">
              <i class="bx bx-support text-orange-600 dark:text-orange-400 text-3xl"></i>
            </div>
            <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-200">
              Soporte
            </h3>
          </div>
          <p class="text-slate-600 dark:text-slate-400 text-sm">
            ¿Necesitas ayuda? Contacta al administrador del sistema para
            obtener asistencia o reportar problemas.
          </p>
        </div>
      </div>

      <!-- Instrucciones adicionales -->
      <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-slate-800 dark:to-slate-700 rounded-lg shadow-sm p-6 mt-6">
        <div class="flex items-start">
          <i class="bx bx-bulb text-yellow-500 dark:text-yellow-400 text-2xl mr-3 mt-1"></i>
          <div>
            <h4 class="font-semibold text-slate-800 dark:text-slate-200 mb-2">
              Comienza a trabajar
            </h4>
            <p class="text-slate-600 dark:text-slate-400 text-sm">
              Explora las opciones del menú lateral izquierdo. Las funciones disponibles dependen de tu rol asignado.
              Si no encuentras lo que buscas, contacta al administrador para solicitar permisos adicionales.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { BRAND } from '@/config/branding';

export default {
  name: 'DashboardGenerico',
  data() {
    return {
      brand: BRAND,
      fechaActual: '',
      horaActual: ''
    };
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    actualizarFechaHora() {
      const ahora = new Date();

      // Formato de fecha: Lunes, 4 de Febrero de 2026
      const opciones = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      this.fechaActual = ahora.toLocaleDateString('es-ES', opciones);

      // Formato de hora: 14:30:45
      this.horaActual = ahora.toLocaleTimeString('es-ES');
    }
  },
  mounted() {
    this.actualizarFechaHora();
    // Actualizar cada segundo
    setInterval(this.actualizarFechaHora, 1000);
  }
};
</script>

<style scoped>
/* Estilos adicionales si son necesarios */
</style>
